/**
 * Conference 관련 유틸 함수 (원본: utils/index.js)
 */
import { CONFERENCE_COMMANDS } from '@/conference/commands';

const ENDED_ROOM_STATUS = 2;

/**
 * 예약 종료 시각(r_end_datetime)은 회의 시간표 정보라서 실제 회의 종료 여부로 쓰지 않는다.
 * 서버가 명시적으로 종료 상태를 내려준 경우에만 종료된 회의로 판단한다.
 */
export const isRoomExplicitlyEnded = (roomInfo: Record<string, unknown>): boolean => {
  const status = roomInfo.r_status;
  if (typeof status !== 'number' && typeof status !== 'string') return false;

  return Number(status) === ENDED_ROOM_STATUS;
};

export const isHttpNotFoundError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;

  const response = (error as { response?: { status?: unknown } }).response;
  return Number(response?.status) === 404;
};

/**
 * 이모지 리액션 업데이트 메시지를 다른 참여자들에게 전송
 * BridgeChannel(data channel)이 준비되지 않은 경우 XMPP sendCommand로 fallback
 * @param emojiUserList 이모지 사용자 목록
 */
export const sendUpdateEmojiUserList = (emojiUserList: Array<{ emoji: string; userId: string; timestamp: number; type?: string }>) => {
  try {
    const room = (window as any)._jitsiRoom;
    if (!room) {
      console.warn('[sendUpdateEmojiUserList] Jitsi room not found');
      return;
    }

    const payload = JSON.stringify(emojiUserList);

    try {
      room.sendEndpointMessage('', {
        name: CONFERENCE_COMMANDS.ENDPOINT_MEET_REACTION,
        id: room.myUserId(),
        emojiUserList: payload,
      });
    } catch (bridgeError) {
      // BridgeChannel이 아직 초기화되지 않은 경우 XMPP command로 fallback
      console.warn('[sendUpdateEmojiUserList] BridgeChannel not ready, using XMPP fallback');
      room.sendCommandOnce(CONFERENCE_COMMANDS.ENDPOINT_MEET_REACTION, {
        value: room.myUserId(),
        attributes: { emojiUserList: payload },
      });
    }
  } catch (e) {
    console.error('[sendUpdateEmojiUserList] Failed to send emoji message:', e);
  }
};
